import {
  columnDefs,
  defaultColDef,
  autoGroupColumnDef,
} from 'components/OrderForm/SamplesFormV2/components/SelectExistingSamplesModal/constants';
import { formatDatetimeStringToDates } from 'utilities/dates_and_times';

export const formatPreviousSamplesGridData = (samples = []) => {
  const orders = {};

  samples.forEach((sample) => {
    if (!sample?.order) return;

    const orderNumber = sample.order.id;

    if (!orders[orderNumber]) {
      orders[orderNumber] = [];
    }

    const {
      name = '',
      created,
      uuid = '',
      id = '',
      control_type: controlType = '',
      organ,
      submission,
    } = sample;

    const projectName = sample.order.project?.name || 'Unknown';
    const orderName = sample.order.name || `Order ${orderNumber}`;
    const submissionName = submission?.name || '';
    const organName = organ?.name || '';
    const submittedAt = created ? formatDatetimeStringToDates(created) : '';

    orders[orderNumber].push({
      order: ['Projects', projectName, orderName, name],
      name,
      submittedIn: submissionName,
      submittedAt,
      uuid,
      organ: organName,
      id,
      controlType,
      sample,
    });
  });

  const rowData = Object.values(orders).flat();

  // sorting by order id desc expecting that most "useful" samples will be at the top
  rowData.sort((a, b) => b.sample.order.id - a.sample.order.id);

  const getDataPath = ({ order }) => order || null;

  return {
    rowData,
    columnDefs,
    defaultColDef,
    autoGroupColumnDef,
    getDataPath,
  };
};
